import {gql} from "@apollo/client";
import {GET_USER_FIELDS} from "../queries/GetUser";


export const UPDATE_PAYMENT_MUTATION = gql`
          ${GET_USER_FIELDS}
          mutation UpdatePaymentMutation($paymentId: String!){
    updatePayment (
            paymentId: $paymentId
    )
    {
        paymentInformation {
            status
            type
            amount
            method {
                    name
            }
            timestamp
            creditTxTimestamp
        }
        user {
            ...GetUserFields
        }
        
    }
}`;
